import { render } from "./paragraph.vue?vue&type=template&id=fbd4f856"
import script from "./paragraph.vue?vue&type=script&lang=js"
export * from "./paragraph.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__